import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { TourProvider } from "@reactour/tour";
import { components } from "@reactour/tour";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
}

function Badge({ children }) {
  const theme = localStorage.getItem("theme");
  return (
    <components.Badge
      styles={{
        badge: (base) => ({
          ...base,
          color: theme === "dark" ? "white" : "black",
          backgroundColor: theme === "light" ? "white" : "black",
        }),
      }}
    >
      {children}
    </components.Badge>
  );
}

const steps = [
  {
    content: "Выберите дату забора от отправителя",
    selector: ".step_1",
  },
  {
    content: "Выберите начальное время забора от отправителя",
    selector: ".step_2",
  },
  {
    content: "Выберите конечное время забора от отправителя",
    selector: ".step_3",
  },
  {
    content: "Найдите через поиск отправителя (если ранее вы уже отправляли)",
    selector: ".step_4",
  },
  {
    content:
      "Выберите тип отправителя (у них поля для заполнения разные). У компании не надо заполнять Фамилию и Отчество. А у врача есть имя пользователя.",
    selector: ".step_5",
  },
  {
    content: "Заполните имя или название компании.",
    selector: ".step_6",
  },
  {
    content: "Заполните электронную почту отправителя.",
    selector: ".step_7",
  },
  {
    content: "Выберите город отправителя.",
    selector: ".step_8",
  },
  {
    content: "Выберите улицу отправителя.",
    selector: ".step_9",
  },
  {
    content: "Напишите номер дома или кв отправителя.",
    selector: ".step_10",
  },
  {
    content: "Напишите номер телефона отправителя.",
    selector: ".step_11",
  },
  {
    content:
      "Напишите комментарии для курьера если он подойдет к отправителю (Пример: Вход сбоку здания).",
    selector: ".step_12",
  },
  {
    content: "Нажмите сохранить чтобы данные отправителя сохранились.",
    selector: ".step_17",
  },
  {
    content: "Получателю те же самые поля что и отправителю заполняете.",
    selector: ".step_13",
  },
  {
    content: "Напишите комментарий к заказу. Это нужно для логистов Компании.",
    selector: ".step_14",
  },
  {
    content:
      "Выберите проекты которые хотите отправить. Заполнив ячейки выбором.",
    selector: ".step_15",
  },
  {
    content: "Нажмите сохранить и все готово!  👌",
    selector: ".step_16",
  },
];

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <TourProvider
      steps={steps}
      disableFocusLock
      styles={{
        popover: (base) => ({
          ...base,
          maxWidth: 500,
          backgroundColor:
            localStorage.getItem("theme") === "light" ? "white" : "black",
        }),
      }}
      components={{ Badge }}
    >
      <App />
    </TourProvider>
  </BrowserRouter>
);
